import React from 'react'

function PrimaryButton({
  onClick,
  ariaLabel,
  text,
  className,
  large,
  icon,
  disabled=false
}) {
  return (
    <div className={`${className} min-w-144`}>
      <button onClick={onClick} disabled={disabled} aria-label={ariaLabel} 
        className={`text-white flex justify-center items-center ${disabled && 'bg-gray-400 cursor-default'} ${!disabled &&'bg-primary'} border rounded ${!disabled &&'hover:bg-primary-light'} ${!large &&  'py-1.5 px-2'} ${large && 'py-3 px-2 text-lg'} w-full`}>
          {icon &&
          <div className='mr-1'>
            {icon}
          </div>}
          {text}
      </button>
    </div>
  )
}

export default PrimaryButton
